export class FormIOModel {
  public BusinessName: string;
  public FormName: string;
  public AdditionalInfo: string;
  public FormConfig: any;
  public Status: number;
  public IsLive: boolean;
  public Module: string;
  public IsRecurringPayment: boolean = false;

  public id: string;
}

export class FormEntryModel {
  public Id: number = 0;
  public FormID: string;
  public Data: object;
}

export class LocationData {
  public Id: number;
  public MID: string;
  public Name: string;
  public Secret_API_Key: string;
}
